import state from './moduleMedsosState.js'
import mutations from './moduleMedsosMutations.js'
import actions from './moduleMedsosActions.js'
import getters from './moduleMedsosGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
